module.exports = __webpack_public_path__ + "static/media/banner2.985b8dc3.png";